module.exports = __webpack_public_path__ + "img/hiw_calendar.svg";